import { getAxiosInstance } from './getAxiosInstance';
import {auth as firebaseAuth} from "../libs/firebase/firebase";
import {config} from "../libs/config/config";

interface Params {
  keyword: string;
  from?: number;
  size?: number;
  sort?: string[];
  options?: any;
}

export const getRoomattachfileIndex = async (params: Params) => {
  const axiosInstance = getAxiosInstance();

  // ToDo: 時間に余裕がある時に認証ヘッダー情報を引数渡しに修正
  const idToken = await firebaseAuth.currentUser?.getIdToken();
  const pathName = await window.location.pathname;

  let addHeaders = {};
  if (typeof pathName === "string") {
    const pathNames = pathName
      .replace(/^\/+/, "")
      .replace(/\/+$/, "")
      .split("/");

    if (config.task.pathNames.includes(pathNames[0]) && pathNames.length === 2) {
      addHeaders = {
        "x-roomId": pathNames[1]
      };
    }
  }

  const headers = {
    "Authorization": `Bearer ${idToken}`
  };

  const response = await axiosInstance.get('/admin/roomattachfile/', {
    params: {
      ...params,
    },
    headers:{
      ...headers,
      ...addHeaders
    }
  });

  return response;
};
